import { TabulatorFull as Tabulator } from 'tabulator-tables';
import { BUILDER_UNKNOWN } from '../utils/constants.js';

const DEFAULT_CLASSES = ["eth", "eth_transfer", "token", "cex", "dex", "defi", "mev", "bridge", "other"]

const formatAddressFromLink = function (cell, formatterParams, onRendered, block_info) {
    var address = cell.getValue();
    var rowData = cell.getRow().getData();
    var label;
    if (block_info.coinbase !== block_info.fee_recipient && block_info.coinbase === address && block_info.builder !== BUILDER_UNKNOWN && block_info.builder !== "") {
        label = block_info.builder
    } else if (rowData.from_label !== undefined && rowData.from_label !== "" && rowData.from_label !== "unknown") {
        label = rowData.from_label
    } else {
        var firstFive = address.slice(0, 5);
        var lastFive = address.slice(-5);
        label = firstFive + "..." + lastFive;
    }
    return `<label style="color: #92d2f6">${label}</label>`;
};

const formatAddressToLink = function (cell, formatterParams, onRendered, block_info) {
    var address = cell.getValue();
    var rowData = cell.getRow().getData();
    var label;
    if (block_info.fee_recipient === address && block_info.validator !== "") {
        label = block_info.validator
    } else if (rowData.target_label !== "" && rowData.target_label !== "unknown" && rowData.class.toLowerCase() !== "mev") {
        label = rowData.target_label
    } else {
        var firstFive = address.slice(0, 5);
        var lastFive = address.slice(-5);
        label = firstFive + "..." + lastFive;
        if (rowData.class.toLowerCase() === "mev") {
            label = "MEV: " + label
        }
    }
    return `<label style="color: #92d2f6">${label}</label>`;
};

function getColorByClass(key) {
    const colorMap = new Map([
        ['eth_transfer', '#26a6ed'],
        ['token', '#00A36C'],
        ['cex', '#ff697c'],
        ['dex', '#4b2caf'],
        ['defi', '#e59c23'],
        ['mev', '#FFFF00'],
        ['bridge', '#8c1434'],
        ['unknown', '#E5E4E2']
    ]);

    if (colorMap.has(key)) {
        return colorMap.get(key);
    } else {
        return colorMap.get('unknown');
    }
}

function hexToRgb(hex) {
    // Remove the "#" symbol if present
    hex = hex.replace("#", "");

    // Extract the red, green, and blue components
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);

    // Return the RGB object
    return {
        r: r,
        g: g,
        b: b
    };
}

function getBackgroundColorByClass(classValue) {
    // Determine the background color based on the class
    var color = getColorByClass(classValue);
    // Set the opacity (alpha) valu
    var opacity = 0.5;
    // Convert the hex color to RGB
    var rgbColor = hexToRgb(color);

    // Combine the RGB values with opacity into the CSS string format
    return `rgba(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}, ${opacity})`;
}

function shortAddress(address) {
    if (address.length >= 10) {
        var firstFive = address.slice(0, 5);
        var lastFive = address.slice(-5);
        return firstFive + "..." + lastFive;
    } else {
        return address
    }
}

function transfersString(transfers) {
    if (transfers.length > 0) {
        var str = "<br>"
        var str = "<strong>Transfers:</strong><br>"
        for (var i = 0; i < transfers.length; i++) {
            var transfer = transfers[i]
            str += `- ${transfer.s} : ${transfer.q / Math.pow(10, transfer.d)} ${shortAddress(transfer.f)} > ${shortAddress(transfer.t)}<br>`
        }
        return str
    } else {
        return ""
    }
}

export default class TxTableUI {

    constructor(element, block_info, block_composition_ui) {
        this.padding = { top: 20, right: 20, bottom: 20, left: 20 };
        var parentDiv = document.querySelector(element); // Replace with the ID of your parent div
        var rect = parentDiv.getBoundingClientRect();
        this.height = rect.height;
        this.width = rect.width;
        this.block_composition_ui = block_composition_ui

        this.table = new Tabulator(element, {
            layout: "fitColumns",
            height: "100%",
            responsiveLayout: "hide",
            maxHeight: "100%",
            tooltipGenerationMode: "hover",
            columnDefaults: {
                tooltip: function (e, cell, onRendered) {
                    var transaction = cell.getRow().getData(); // Get the row data

                    var method_id = "";
                    if (transaction.method_id !== "") {
                        method_id = `<strong style="display: inline-block; width: 100px;">Method Id:</strong> ${transaction.method_id}<br>`
                    }
                    var method = "";
                    if (transaction.method !== "" && transaction.method !== "<unknown>") {
                        var methods = transaction.method.split(";");
                        if (methods.length > 1) {
                            const maxDisplayed = 5;
                            const numHidden = methods.length - maxDisplayed;
                            if (numHidden > 0) {
                                methods = methods.slice(0, maxDisplayed);
                                methods.push("..." + numHidden + " more");
                            }
                            methods = methods.join(`<br><strong style="display: inline-block; width: 100px;"></strong> `)
                            method = `<strong style="display: inline-block; width: 100px;">Method:</strong> ${methods}<br>`;
                        } else {
                            method = `<strong style="display: inline-block; width: 100px;">Method:</strong> ${transaction.method}<br>`;
                        }
                    }

                    var el = document.createElement("div"); // Create the new element
                    var parent = document.querySelector(".inner"); // Select the parent element
                    if (parent) {
                        parent.appendChild(el); // Append the new element as a child of the parent
                    }
                    el.className = "tooltip-tx-tab"; // Use className instead of class
                    el.innerHTML = `
                        <strong>Hash ${transaction.hash}</strong><br><br>
                        <strong style="display: inline-block; width: 100px;">Position:</strong> ${transaction.position}<br>
                        <strong style="display: inline-block; width: 100px;">Class:</strong> ${transaction.class.toUpperCase()}<br>
                        <strong style="display: inline-block; width: 100px;">From:</strong> ${transaction.from}<br>
                        <strong style="display: inline-block; width: 100px;">To:</strong> ${transaction.to}<br>
                        ${method}
                        ${method_id}
                        <strong style="display: inline-block; width: 100px;">Value:</strong> ${transaction.value} ETH<br>
                        <strong style="display: inline-block; width: 100px;">Gas Used:</strong> ${transaction.gas_used}<br>
                        <strong style="display: inline-block; width: 100px;">Tip:</strong> ${(transaction.tip * 1e9).toFixed(2)} Gwei<br>
                        <strong style="display: inline-block; width: 100px;">Tip Reward:</strong> ${transaction.tip_reward} ETH<br>
                        <strong style="display: inline-block; width: 100px;">Coinbase:</strong> ${transaction.coinbase} ETH<br>
                        ${transfersString(transaction.transfers)}
                    `
                    return el;
                },
            },
            initialSort: [
                { column: "position", dir: "asc" } // Replace "columnName" with the actual column name you want to sort by
            ],
            rowFormatter: (row) => {
                var rowData = row.getData()

                // add other styles
                row.getElement().style.height = "24px";
                row.getElement().style.color = "#fff";
                row.getElement().style.backgroundColor = "#202124";
                row.getElement().style.background = "#202124";

                if (rowData.position !== undefined && rowData.class !== undefined) {
                    // Add the custom class to the row
                    row.getElement().classList.add(`tx-table-row-position-${rowData.position}`);
                    // add other styles
                    row.getElement().style.background = getBackgroundColorByClass(rowData.class.toLowerCase());
                    // row.getElement().style.opacity = "0.9";
                    row.getElement().style.cursor = "pointer";
                    if (rowData.from === this.block_info.coinbase) {
                        row.getElement().style.fontWeight = "600";
                    }

                    // Add the mouseover event listener to add the hover class
                    row.getElement().addEventListener('mouseover', (event) => {
                        // highlight
                        row.getElement().classList.add('highlighted');
                        const selector = `.tx-block-composition-position-${rowData.position}`;
                        const elements = document.querySelectorAll(selector);
                        elements.forEach(element => {
                            element.classList.add('highlighted');
                        });
                    });
                    // Add the mouseout event listener to remove the hover class
                    row.getElement().addEventListener('mouseout', () => {
                        // remove highlight
                        row.getElement().classList.remove('highlighted');
                        const selector = `.tx-block-composition-position-${rowData.position}`;
                        const elements = document.querySelectorAll(selector);
                        elements.forEach(element => {
                            element.classList.remove('highlighted');
                        });
                    });
                }
            },
            cellFormatter: function (cell) {
                cell.getElement().style.height = "24px";
            },
            columns: [
                {
                    title: "#", field: "position", sorter: "number", headerSort: true, hozAlign: "left", width: "45",
                    topCalc: (values, data, calcParams) => {
                        return data.length; // Return the count of rows
                    },
                    cellClick: (e, cell) => {
                        const row = cell.getRow();
                        const rowData = row.getData();
                        this.navigateToEtherscan(rowData.hash)
                    }
                },
                {
                    title: "Class", field: "class", sorter: "string", headerSort: true, hozAlign: "left", width: "115",
                    cellClick: (e, cell) => {
                        const row = cell.getRow();
                        const rowData = row.getData();
                        this.navigateToEtherscan(rowData.hash)
                    }
                },
                {
                    title: "From", field: "from", sorter: "string", headerSort: true, hozAlign: "left", width: "150",
                    formatter: (cell, formatterParams, onRendered) => {
                        return formatAddressFromLink(cell, formatterParams, onRendered, this.block_info);
                    },
                    cellClick: (e, cell) => {
                        const value = cell.getValue();
                        this.copyToClipboard(value);
                    },
                    tooltip: function (e, cell, onRendered) {
                        var el = document.createElement("div");
                        el.className = "tooltip-tx-tab"; // Use className instead of class
                        el.innerHTML = cell.getValue() + " &#x2398;";
                        return el;
                    },
                },
                {
                    title: "To", field: "to", sorter: "string", headerSort: true, hozAlign: "left",
                    formatter: (cell, formatterParams, onRendered) => {
                        return formatAddressToLink(cell, formatterParams, onRendered, this.block_info);
                    },
                    cellClick: (e, cell) => {
                        const value = cell.getValue();
                        this.copyToClipboard(value);
                    },
                    tooltip: function (e, cell, onRendered) {
                        var el = document.createElement("div");
                        el.className = "tooltip-tx-tab"; // Use className instead of class
                        el.innerHTML = cell.getValue() + " &#x2398;";
                        return el;
                    },
                },
                {
                    title: "Value", field: "value", sorter: "number", headerSort: true, headerSortStartingDir: "desc", hozAlign: "left", width: "110", topCalc: "sum",
                    formatter: (cell, formatterParams, onRendered) => {
                        var value = cell.getValue();

                        var formattedValue = parseFloat(value).toFixed(8);
                        if (formattedValue > 0) {
                            return formattedValue;
                        } else {
                            return "-"
                        }
                    },
                    topCalcFormatter: (cell) => {
                        const sum = cell.getValue();
                        if (sum === 0) {
                            return "-"
                        }
                        return sum.toFixed(8); // Format the sum with two decimal places
                    },
                    cellClick: (e, cell) => {
                        const row = cell.getRow();
                        const rowData = row.getData();
                        this.navigateToEtherscan(rowData.hash)
                    }
                },
                {
                    title: "Reward", field: "reward", sorter: "number", headerSort: true, headerSortStartingDir: "desc", hozAlign: "left", width: "110", topCalc: "sum",
                    formatter: (cell, formatterParams, onRendered) => {
                        var value = cell.getValue();
                        var formattedValue = parseFloat(value).toFixed(8);

                        return formattedValue;
                    },
                    topCalcFormatter: (cell) => {
                        var sum = cell.getValue();
                        return sum.toFixed(8); // Format the sum with two decimal places
                    },
                    cellClick: (e, cell) => {
                        const row = cell.getRow();
                        const rowData = row.getData();
                        this.navigateToEtherscan(rowData.hash)
                    }
                },
                {
                    title: "Gas", field: "gas", sorter: "number", headerSort: true, headerSortStartingDir: "desc", hozAlign: "left", width: "80", topCalc: "sum",
                    cellClick: (e, cell) => {
                        const row = cell.getRow();
                        const rowData = row.getData();
                        this.navigateToEtherscan(rowData.hash)
                    }
                },
                {
                    title: "R %", field: "share_reward", sorter: "number", headerSort: false, hozAlign: "left", width: "60", topCalc: "sum",
                    topCalcFormatter: (cell) => {
                        var sum = cell.getValue();
                        if (sum > 100) {
                            sum = 100
                            return sum.toFixed(0);
                        } else {
                            return sum.toFixed(2); // Format the sum with two decimal places
                        }
                    },
                    cellClick: (e, cell) => {
                        const row = cell.getRow();
                        const rowData = row.getData();
                        this.navigateToEtherscan(rowData.hash)
                    }
                },
                {
                    title: "G %", field: "share_gas", sorter: "number", headerSort: false, hozAlign: "left", width: "60", topCalc: "sum",
                    topCalcFormatter: (cell) => {
                        var sum = cell.getValue();
                        if (sum > 100) {
                            sum = 100
                            return sum.toFixed(0);
                        } else {
                            return sum.toFixed(2); // Format the sum with two decimal places
                        }
                    },
                    cellClick: (e, cell) => {
                        const row = cell.getRow();
                        const rowData = row.getData();
                        this.navigateToEtherscan(rowData.hash)
                    }
                },
            ],
        });

        // Listen for the "tableBuilt" event
        this.table.on("tableBuilt", () => {
            this.setBlockInfo(block_info)
        });

        this.table.on("dataSorted", (sorters, rows) => {
            if (rows.length > 0) {
                const sortedData = rows.map(row => row.getData());
                this.block_composition_ui?.setTransactions(sortedData)
            }
        });

        this.setupFilter()
        this.setupCopyClipboard()
    }

    setupFilter = () => {
        var filterInput = document.getElementById('filter-input-tx-table');
        var filterTimer;

        filterInput.addEventListener('input', () => {
            clearTimeout(filterTimer);
            filterTimer = setTimeout(() => {
                this.filter(filterInput.value.toLowerCase())
            }, 200); // Adjust the delay as desired (in milliseconds)
        });

        // Get all the checkbox elements
        const checkboxes = document.querySelectorAll('input[type="checkbox"]');
        this.selectedClasses = [...DEFAULT_CLASSES]

        // add listener to reset button
        const resetButton = document.getElementById("reset-button-tx");
        resetButton.addEventListener("click", () => {
            // Check if the table is sorted
            const sorters = this.table.getSorters();

            if (this.selectedClasses.length >= DEFAULT_CLASSES.length && filterInput.value === "" && (sorters.length === 1 && sorters[0].field === "position")) {
                this.selectedClasses = []
                filterInput.value = ""
                checkboxes.forEach(checkbox => {
                    checkbox.checked = false
                })
            } else {
                this.selectedClasses = [...DEFAULT_CLASSES]
                filterInput.value = ""
                checkboxes.forEach(checkbox => {
                    checkbox.checked = true
                })
                this.table.clearSort();
                this.table.setSort("position", "asc");
            }
            this.filter(filterInput.value)
        });


        // Add event listener to each checkbox
        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', () => {
                // Extract the second part of the id attribute
                const idParts = checkbox.id.split('-');
                const firstPart = idParts[0];
                var secondPart = idParts[1];

                // HOTFIX: for eth-transfer
                if (secondPart.toLowerCase() === "eth") {
                    secondPart = "eth_transfer"
                }
                if (firstPart === "class") {
                    if (checkbox.checked) {
                        this.selectedClasses.push(secondPart.toLowerCase());
                    } else {
                        this.selectedClasses = this.selectedClasses.filter(item => item !== secondPart.toLowerCase());
                    }
                    this.filter(filterInput.value.toLowerCase())
                }
            });
        });
    }

    setBlockInfo = (block_info) => {
        this.block_info = block_info
        this.setTransactions(block_info.transactions)
    }

    setTransactions = (transactions) => {
        var rows = []
        for (var i = 0; i < transactions.length; i++) {
            var info = transactions[i];
            rows.push(this.processTransactionInfo(this.block_info, info))
        }
        this.table.setData(rows);
        this.setupCopyClipboard()
    }

    filter = (str) => {
        var filteredTransactions;
        if (str !== "") {
            str = str.toLowerCase()
            filteredTransactions = this.block_info.transactions.filter(transaction =>
                (transaction.position === str ||
                    transaction.class.toLowerCase().includes(str) ||
                    transaction.hash.includes(str) ||
                    transaction.from.toLowerCase().includes(str) ||
                    transaction.to.toLowerCase().includes(str) ||
                    transaction.target_label.toLowerCase().includes(str)) &&
                this.selectedClasses.includes(transaction.class.toLowerCase())
            );
        } else {
            filteredTransactions = this.block_info.transactions.filter(transaction =>
                this.selectedClasses.includes(transaction.class.toLowerCase())
            );
        }
        this.setTransactions(filteredTransactions)
        if (filteredTransactions.length > 0) {
            this.block_composition_ui?.setTransactions(filteredTransactions)
        }
    }

    processTransactionInfo = (block_info, transaction_info) => {
        var row = transaction_info;
        row.class = transaction_info.class.toUpperCase()
        row.reward = transaction_info.tip_reward + transaction_info.coinbase
        row.gas = transaction_info.gas_used
        row.share_reward = ((transaction_info.tip_reward + transaction_info.coinbase) / (block_info.payment + block_info.payout) * 100).toFixed(2)
        row.share_gas = ((transaction_info.gas_used / block_info.gas_used) * 100).toFixed(2)
        return row
    }

    setupCopyClipboard = () => {
        const copyOverlay = document.getElementById("copy-overlay");

        this.showCopyOverlay = (message) => {
            copyOverlay.textContent = message;
            copyOverlay.classList.add("show-overlay");
            setTimeout(() => {
                copyOverlay.classList.remove("show-overlay");
            }, 2000);
        }
    }

    copyToClipboard = (value) => {
        navigator.clipboard
            .writeText(value)
            .then(() => {
                this.showCopyOverlay("Copied to clipboard!");
            })
            .catch((error) => {
                console.error("Failed to copy string:", error);
                this.showCopyOverlay("Copy failed!");
            });
    }

    navigateToEtherscan = (tx_hash) => {
        const url = `https://etherscan.io/tx/${tx_hash}`;
        // Open the URL in a new tab
        window.open(url, "_blank");
    }
}